import { useTheme } from '@famly/mf_theme';
import { useWhitelabelConfiguration } from 'signin-app/whitelabel/use-whitelabel-configuration';
export const useCustomWhitelabelColor = (colorKey) => {
    var _a;
    const whitelabelConfiguration = useWhitelabelConfiguration();
    const theme = useTheme();
    return (_a = whitelabelConfiguration[colorKey]) !== null && _a !== void 0 ? _a : theme.colorPalette[colorKey];
};
